<!-- BEGIN 401 error -->
<div class="error">
    <div class="error-code">401</div>
    <div class="error-content">
        <div class="error-message">Unauthorized Access</div>
        <div class="error-desc mb-4">
            You do not have permission to view this page. <br />
            Please log in to continue.
        </div>
        <div>
            <a routerLink="/account/login" class="btn btn-success px-3">Back to Login</a>
        </div>
    </div>
</div>
<!-- END 401 error -->